// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-group ::ng-deep .form-control:first-child {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.input-group ::ng-deep .form-control {
  position: relative;
  z-index: 2;
  margin-bottom: 0;
}

@media (min-width: 768px) {
  .form-inline .input-group ::ng-deep .form-control {
    width: 100%;
  }
}
.input-group-addon ::ng-deep .form-control, .input-group-btn ::ng-deep .form-control, .input-group ::ng-deep .form-control {
  display: table-cell;
}

.input-group-sm ::ng-deep .form-control, .input-group-sm .input-group-addon, .input-group-sm .input-group-btn > ::ng-deep .btn {
  height: 33px;
  padding: 5px 10px;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 3px;
}

form-numeric-input-bootstrap {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/gamma/form/formquestion/bootstrap/numeric/numeric.component.scss"],"names":[],"mappings":"AACI;EACI,6BAAA;EACA,0BAAA;AAAR;AAEI;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;AAAR;;AAGA;EAEQ;IACI,WAAA;EADV;AACF;AAKI;EACI,mBAAA;AAHR;;AAOA;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,aAAA;AAJJ","sourcesContent":[".input-group {\n    ::ng-deep .form-control:first-child {\n        border-bottom-right-radius: 0;\n        border-top-right-radius: 0;\n    }\n    ::ng-deep .form-control {\n        position: relative;\n        z-index: 2;\n        margin-bottom: 0;\n    }\n}\n@media (min-width: 768px) {\n    .form-inline .input-group {\n        ::ng-deep .form-control {\n            width: 100%;\n        }\n    }\n}\n.input-group-addon, .input-group-btn, .input-group {\n    ::ng-deep .form-control {\n        display: table-cell;\n    }\n}\n\n.input-group-sm ::ng-deep .form-control, .input-group-sm .input-group-addon, .input-group-sm .input-group-btn > ::ng-deep .btn {\n    height: 33px;\n    padding: 5px 10px;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 3px;\n}\n\nform-numeric-input-bootstrap {\n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
